import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

// Defina as fontes
pdfMake.addVirtualFileSystem(pdfFonts)

async function gerarRelatorioUltimosDias(daysOfSales, data) {
  console.log(data)

  const currentDate = new Date().toLocaleString('pt-BR')
  const username = localStorage.username || 'usuario'

  const documentDefinition = {
    content: [
      {
        text: `Relatório de Vendas dos Últimos ${daysOfSales} dias `,
        fontSize: 20,
        alignment: 'center',
        margin: 10,
      },
      {
        text: `Data e Hora de Impressão: ${currentDate}`,
        fontSize: 10,
        alignment: 'right',
        margin: [0, 0, 20, 10],
      },
      {
        text: `Usuário: ${username}`,
        fontSize: 10,
        alignment: 'right',
        margin: [0, 0, 20, 10],
      },
      { text: ' ', margin: 10 },
      {
        table: {
          headerRows: 1,
          widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto'], // Define larguras fixas para cada coluna
          body: [
            [
              { text: 'SKU', fontSize: 8 },
              { text: 'PRODUTO', fontSize: 8 },
              { text: 'VENDAS', fontSize: 8 },
              { text: 'ESTOQUE', fontSize: 8 },
              { text: 'MDV', fontSize: 8 },
              { text: 'DDE', fontSize: 8 }, // Adiciona a coluna DDE
            ],
            ...data.map((item) => [
              { text: item.CODPROD, fontSize: 8 },
              { text: item.DESCRICAO, fontSize: 8 },
              { text: item.VENDA, fontSize: 8 },
              { text: item.ESTOQUE, fontSize: 8 },
              { text: item.MD_VENDA.toFixed(2), fontSize: 8 },
              {
                text:
                  item.ESTOQUE !== 0 && item.MD_VENDA !== 0
                    ? (item.ESTOQUE / item.MD_VENDA).toFixed(2)
                    : '0.00',

                fontSize: 8,
              }, // Calcula e exibe a DDE
            ]),
          ],
          fontSize: 8, // Define o tamanho da fonte da tabela como 8
        },
      },
    ],
  }

  pdfMake.createPdf(documentDefinition).open()
}

export { gerarRelatorioUltimosDias }
